module.exports = __webpack_public_path__ + "static/media/03-covid.fb4462c8.jpg";